import React from 'react'

import cashEventImage from '@assets/images/cashflow_event_image.png'

import { BackToDashboardButton } from '../../Components/BackToDashboardButton'
import { RefreshButton } from '../../Components/RefreshButton'

export const CheckingConsentRequirement = () => {
  return (
    <div className='astute-request-wrapper'>
      <h1>Checking digital consent status</h1>
      <p className='astute-request-wrapper--subheading'>
    We're checking your client's consent status on Astute
      </p>
      <img
        src={cashEventImage}
        alt='astute pending graphic'
        className='astute-request-wrapper--graphic'
      />
      <p className='astute-request-wrapper--link-text'>
        If your client has provided consent in the last 12 months, we'll be able to retrieve their data immediately, otherwise Astute will request consent from your client.
      </p>
      <div className='astute-back-to-dashboard'>
        <BackToDashboardButton />
        <div className='refresh-button-wrapper'>
          <RefreshButton />
        </div>
      </div>
    </div>
  )
}
